import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

import dogThumbnail from '../../assets/images/thumbnail/dog.jpg';
import catThumbnail from '../../assets/images/thumbnail/cat.jpg';
import hamsterThumbnail from '../../assets/images/thumbnail/hamster.jpg';
import parrotThumbnail from '../../assets/images/thumbnail/parrot.jpg';

import ServiceText from '../common/serviceText';
import ThumbnailGallery from './../common/thumbnailGallery';

const Section = Styled.section.attrs((props) => ({ id: 'about' }))`
padding: 5rem 0;
background: ${color.white};
display: grid;
grid-template-columns: repeat(2, 1fr);
place-content:center;
@media only screen and (max-width:770px){
  padding-bottom: 20rem;
  grid-template-columns: 1fr;
  place-items:center;
  place-content:center};
}`;

const About = () => {
  return (
    <Section>
      <ServiceText
        heading={'Expert care for your furry, feathery, or scaley friend'}
        paragraph={
          'We know how stressful it is to leave your pets at home alone. We’re a team of experienced animal caregivers, well connected to local veterinarians. Trust to us to love them like our own, and to keep them safe and happy till you’re home'
        }
      />
      <ThumbnailGallery
        images={[
          { label: 'Natasha', img: dogThumbnail },
          { label: 'Muffin', img: catThumbnail },
          { label: 'Marlon', img: hamsterThumbnail },
          { label: 'Peep', img: parrotThumbnail },
        ]}
      />
    </Section>
  );
};

export default About;
